function getMessage(field, args) {
  return `${field} value must be not be 0.`
}

function validate(value, args) {
  if (value) {
    value = '' + value // If a format other den str, it doesnt has replace
    const valueWithoutMask = value.replace(/,/g, '')
    const args = valueWithoutMask.split('.')
    const zero = Number(args[0]) === 0 && Number(args[1]) === 0
    return !zero
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
